export const pasteCapture = (event, editor_ref) => {
    let text, onPasteStripFormattingIEPaste
    event.preventDefault()

    if (event.originalEvent && event.originalEvent.clipboardData.getData) {
        text = event.originalEvent.clipboardData.getData('text/plain')
        editor_ref.runCmd('insertText', text)
    } else if (event.clipboardData && event.clipboardData.getData) {
        text = event.clipboardData.getData('text/plain')
        editor_ref.runCmd('insertText', text)
    } else if (window.clipboardData && window.clipboardData.getData) {
        if (!onPasteStripFormattingIEPaste) {
            onPasteStripFormattingIEPaste = true
            editor_ref.runCmd('ms-pasteTextOnly', text)
        }
        onPasteStripFormattingIEPaste = false
    }
}